import Box from "@mui/joy/Box";
import SubjectIcon from "@mui/icons-material/Subject";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { Button, Card, Grid, Link } from "@mui/material";
import { Transaction } from "../../openApi/api";
import { useNavigate } from "react-router-dom";
import { CalculatePassTime } from "../../utils";

interface Props {
  txs: Transaction[];
}

const Transactions = ({ txs }: Props) => {
  const navigate = useNavigate();
  return (
    <>
      <Card
        sx={{ minWidth: 275 }}
        className="card mb-4 mt-n12"
        variant="outlined"
      >
        <div className="card-header d-flex justify-content-between align-items-center bg-light">
          <div className="d-flex justify-content-between align-items-center gap-1">
            <h2 className="card-header-title">Latest Transactions</h2>
          </div>

          <Button
            component="button"
            className="btn btn-sm btn-white align-items-center"
            color="inherit"
            variant="outlined"
            sx={{
              border:
                "var(--bs-btn-border-width) solid var(--bs-btn-border-color);",
              fontSize: "var(--bs-btn-font-size)",
              color: "var(--bs-btn-color)",
              textTransform: "unset",
            }}
            startIcon={<SubjectIcon />}
            onClick={() => navigate("/txs")}
          >
            View All
          </Button>
        </div>
        <Box
          sx={{ flexGrow: 1 }}
          className="card-body overflow-auto scrollbar-custom striped-style p-0"
        >
          {txs.map((data, index) => {
            return (
              <Grid container className="table-item" key={`txs_${index}`}>
                <Grid item xs={4}>
                  <div className="d-flex align-items-center gap-2">
                    <div className="d-none d-sm-flex content-center bg-light text-muted rounded p-3 ms-2">
                      <AssignmentIcon />
                    </div>
                    <div className="d-flex align-items-center align-items-sm-start flex-row flex-sm-column gap-1 gap-sm-0">
                      <span className="d-inline-block d-sm-none">Block</span>
                      <Link
                        className="d-block text-truncate"
                        href={`/tx/${data.txId}?blockNum=${data.blockNum}`}
                      >
                        {data.txId}
                      </Link>
                      <div className="small text-muted">
                        {" "}
                        {CalculatePassTime(
                          new Date(data.timestamp.substring(0, 19))
                        )}{" "}
                        ago
                      </div>
                    </div>
                  </div>
                </Grid>
                <Grid
                  item
                  xs={8}
                  className="d-flex justify-content-sm-between align-items-end align-items-sm-center position-relative"
                >
                  <div className="pe-0 pe-sm-2">
                    <div className="d-flex flex-wrap gap-1">
                      From{" "}
                      <Link
                        className="text-truncate d-block"
                        href={`/address/${data.sender}`}
                        data-bs-toggle="tooltip"
                      >
                        {data.sender}
                      </Link>
                    </div>
                    <div className="d-flex align-items-center flex-wrap gap-1">
                      To{" "}
                      <a
                        href={`/address/${data.receiver}`}
                        data-bs-toggle="tooltip"
                      >
                        {data.receiver}
                      </a>
                    </div>
                  </div>

                  <div className="d-none d-sm-block text-end ms-2 ms-sm-0">
                    <span
                      className="badge text-dark fw-medium py-1.5 px-2"
                      data-bs-toggle="tooltip"
                    >
                      {data.fee.toFixed(5)} UPC
                    </span>
                  </div>
                </Grid>
              </Grid>
            );
          })}
        </Box>

        {/* <Link
          className="card-footer bg-light fw-bold text-cap link-muted text-center"
          href="/#"
        >
          View all Transactions&nbsp;
          <TrendingFlatIcon fontSize="small" />
        </Link> */}
      </Card>
    </>
  );
};

export default Transactions;
